import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

import {
	PRISM_DIALOG_DATA,
	PrismButtonComponent,
	PrismCheckboxComponent,
	PrismDialogComponent,
	PrismDialogRef,
	PrismIconComponent
} from '@shure/prism-angular-components';
import { provideInlineScope } from '@shure/shared/angular/utils/i18n';

import { ConfirmDialogData, DialogBody, ShowIcon } from '../confirm-dialog.component.models';

export interface PrismConfirmDialogData extends ConfirmDialogData {
	confirmVariant?: 'standard' | 'bright' | 'text' | 'warning';
	confirmDisabled?: boolean;
	autofocus?: 'confirmButton' | 'cancelButton';
}

@Component({
	selector: 'sh-prism-confirm-dialog',
	templateUrl: './prism-confirm-dialog.component.html',
	styleUrls: ['./prism-confirm-dialog.component.scss'],
	standalone: true,
	imports: [
		CommonModule,
		TranslocoModule,
		PrismButtonComponent,
		PrismCheckboxComponent,
		PrismDialogComponent,
		PrismIconComponent
	],
	providers: [provideInlineScope('scConfirmDialog', (lang) => import(`../../i18n/${lang}`))]
})
export class PrismConfirmDialogComponent {
	protected doNotShowDialog = false;
	protected readonly showIcon = ShowIcon;

	constructor(
		@Inject(PRISM_DIALOG_DATA) public readonly data: PrismConfirmDialogData,
		private readonly dialogRef: PrismDialogRef<PrismConfirmDialogComponent>
	) {}

	protected toggleDoNotShowDialog(doNotShowDialog: boolean): void {
		this.doNotShowDialog = doNotShowDialog;
	}

	protected isTextObject(line: string | DialogBody): line is DialogBody {
		return typeof line !== 'string';
	}

	protected closeDialog(result: { confirmed: boolean; doNotShowDialog: boolean }): void {
		this.dialogRef.close(result);
	}
}
